export default __webpack_public_path__ + "static/media/deliveryVisuals@2x.b0a2c888.png";